import styled from 'styled-components';
import { mediaQuery } from '../../../common/styles/styleUtil';

export const FAQContainer = styled.div<{ deviceType: string }>`
  margin-top: 14px;
  border-top: 1px solid #d2d6da;
  padding-top: 32px;

  @media (${mediaQuery.mobile}) {
    padding: 0 16px;
    padding-top: 32px;
    margin-bottom: 32px;
  }
`;

export const FAQWrapper = styled.div``;

export const FAQItem = styled.div`
  border-bottom: 1px solid #eee;
  padding: 0px 8px;
`;

export const FAQHeading = styled.button`
  font-size: 18px;
  font-weight: 400;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0px;
  margin-bottom: 0px;
  background: transparent;
  border: 0;
  margin: 0;
  width: 100%;
  text-align: left;
  gap: 16px;
`;

export const Icon = styled.span<{ isActive: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform: ${({ isActive }) =>
    isActive ? 'rotate(180deg)' : 'rotate(0deg)'};

  transform-origin: center;
  will-change: transform;
`;

export const FAQContent = styled.section`
  font-size: 16px;
  line-height: 20px;
  font-weight: 300;
  color: #697684;
  padding-top: 8px;
  padding-bottom: 12px;
`;

export const FAQTitle = styled.h2`
  font-size: 24px;
  font-weight: 500;
  line-height: 28px;
  color: #000000;
  text-align: left;
  margin-bottom: 0px;
`;
